import { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';

import RadioGroup from '@/components/common/RadioGroup/RadioGroup.tsx';
import { Gender } from '@/enums/apiEnums.ts';
import { InputContent } from '@/components/common/InputContent/InputContent.tsx';
import GenderMaleShape from '@/components/common/svg/shapes/GenderMaleShape.tsx';
import GenderFemaleShape from '@/components/common/svg/shapes/GenderFemaleShape.tsx';

type GenderRadioGroupProps = {
  gender: string;
  updateFields: (fields: Partial<{ gender: string }>) => void;
};

export const GenderRadioGroup = ({
  gender,
  updateFields
}: GenderRadioGroupProps) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    updateFields({ gender: e.target.value });
  };

  const { t } = useTranslation();

  return (
    <InputContent
      title={t('sex_section').toUpperCase()}
      style={{ marginTop: '24px', paddingBottom: '10px' }}
      styleTitle={{ fontWeight: 510, fontSize: 12, color: '#787878' }}
    >
      <RadioGroup
        data={[
          {
            value: Gender.MALE,
            label: t('registration.male_gender'),
            icon: <GenderMaleShape />
          },
          {
            value: Gender.FEMALE,
            label: t('registration.female_gender'),
            icon: <GenderFemaleShape />
          }
        ]}
        handleChange={handleChange}
        selected={gender}
      />
    </InputContent>
  );
};
